import script from "./printerManage.vue?vue&type=script&setup=true&lang=js"
export * from "./printerManage.vue?vue&type=script&setup=true&lang=js"

import "./printerManage.vue?vue&type=style&index=0&id=5cc5c72e&lang=scss"

const __exports__ = script;

export default __exports__